import React, { useState } from "react";
import "./OperationalReadout.css";

const OperationalReadout = () => {
  const [activeTab, setActiveTab] = useState("OVERALL");
  const [searchQuery, setSearchQuery] = useState("");

  const tabs = ["OVERALL", "WEB", "CRYPTO", "REVERSE", "FORENSICS"];

  const operators = [
    {
      rank: "#1",
      callsign: "CYBER_PHOENIX",
      lastTransmission: "2 min ago",
      progress: 95,
    },
    {
      rank: "#2",
      callsign: "FLAG_HUNTER",
      lastTransmission: "5 min ago",
      progress: 88,
    },
    {
      rank: "#3",
      callsign: "DECRYPT_MASTER",
      lastTransmission: "8 min ago",
      progress: 82,
    },
    {
      rank: "#4",
      callsign: "REVERSE_ENGINEER",
      lastTransmission: "12 min ago",
      progress: 75,
    },
    {
      rank: "#5",
      callsign: "WEB_EXPLOITER",
      lastTransmission: "15 min ago",
      progress: 68,
    },
    {
      rank: "#6",
      callsign: "FORENSICS_PRO",
      lastTransmission: "20 min ago",
      progress: 60,
    },
  ];

  const filteredOperators = operators.filter(
    (operator) =>
      operator.callsign.toLowerCase().includes(searchQuery.toLowerCase()) ||
      operator.rank.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="operational-readout">
      <div className="readout-header">
        <h1>//LEADERBOARD</h1>
        <div className="readout-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="operators-table">
        <div className="table-header">
          <div className="header-cell">RANK</div>
          <div className="header-cell">TEAM_NAME</div>
          <div className="header-cell">LAST_ACTIVITY</div>
          <div className="header-cell">SCORE</div>
        </div>

        <div className="table-body">
          {filteredOperators.map((operator, index) => (
            <div
              key={index}
              className={`table-row ${
                index === 1 || index === 5 ? "highlighted" : ""
              }`}
            >
              <div className="table-cell rank-cell">{operator.rank}</div>
              <div className="table-cell callsign-cell">
                {operator.callsign}
              </div>
              <div className="table-cell transmission-cell">
                {operator.lastTransmission}
              </div>
              <div className="table-cell progress-cell">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${operator.progress}%` }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="search-section">
        <div className="search-input-container">
          <span className="search-prompt">&gt; find_team:</span>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
            placeholder=""
          />
        </div>
      </div>

      <div className="live-intel-feed">
        <div className="intel-header">
          <span className="intel-title">LIVE INTEL FEED</span>
        </div>
        <div className="intel-stats">
          <div className="stat-item">
            <span className="stat-text">ACTIVE TEAMS: 1337</span>
          </div>
          <div className="stat-item">
            <span className="stat-text">FLAGS CAPTURED: 42</span>
          </div>
          <div className="stat-item">
            <span className="stat-text">TOTAL SCORE: 89,500 pts</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalReadout;
